function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSollet = function SvgSollet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#00ffa3",
      fillOpacity: 1
    },
    d: "M4.695 19.703a.902.902 0 0 1 .637-.262h22c.402 0 .602.485.32.77l-4.347 4.344a.902.902 0 0 1-.637.261h-22a.452.452 0 0 1-.32-.77ZM4.695 3.484a.902.902 0 0 1 .637-.261h22c.402 0 .602.484.32.77l-4.347 4.343a.902.902 0 0 1-.637.262h-22a.452.452 0 0 1-.32-.77ZM23.305 11.574a.902.902 0 0 0-.637-.261h-22a.452.452 0 0 0-.32.769l4.347 4.344a.902.902 0 0 0 .637.262h22a.452.452 0 0 0 .32-.77Zm0 0"
  }));
};
export default SvgSollet;